import { render, staticRenderFns } from "./MatchdayTakeover.vue?vue&type=template&id=b522866a&scoped=true"
import script from "./MatchdayTakeover.vue?vue&type=script&lang=js"
export * from "./MatchdayTakeover.vue?vue&type=script&lang=js"
import style0 from "./MatchdayTakeover.vue?vue&type=style&index=0&id=b522866a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b522866a",
  null
  
)

export default component.exports